(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-scrolling"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('taidongo-shipping-banner')) {
  customElements.define('taidongo-shipping-banner', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.totalElement = this.querySelector('[data-shipping-total]');
      this.resultElement = this.querySelector('[data-shipping-result]');
      this.detailElement = this.querySelector('[data-shipping-detail]');
      this.threshold = Number(this.dataset.threshold);
      this.headerElement = document.querySelector('.section-header');
      this.layoutHandler = () => {
        this.headerElement ||= document.querySelector('.section-header');
        const height = Math.ceil(this.getBoundingClientRect().height);
        if (height > 0) this.headerElement?.style.setProperty('--td-shipping-offset', `${height}px`);
      };
      this.layoutObserver = new ResizeObserver(this.layoutHandler);
      this.layoutObserver.observe(this);
      this.layoutHandler();
      this.refreshHandler = () => this.queueRefresh();
      this.readyHandler = () => this.bindCart();
      document.addEventListener('cart:updated', this.refreshHandler);
      document.addEventListener('cart:open', this.refreshHandler);
      window.addEventListener('pageshow', this.refreshHandler);
      window.addEventListener('focus', this.refreshHandler);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.readyHandler, { once: true });
      } else {
        this.bindCart();
      }
    }

    bindCart() {
      if (this.bound) return;
      this.bound = true;
      this.layoutHandler();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refreshHandler);
      }
      const counter = document.getElementById('cart-icon-bubble');
      if (counter) {
        this.counterObserver = new MutationObserver(this.refreshHandler);
        this.counterObserver.observe(counter, { childList: true, subtree: true, characterData: true });
      }
      this.queueRefresh();
    }

    disconnectedCallback() {
      clearTimeout(this.refreshTimer);
      this.requestController?.abort();
      this.unsubscribe?.();
      this.counterObserver?.disconnect();
      this.layoutObserver?.disconnect();
      this.headerElement?.style.removeProperty('--td-shipping-offset');
      document.removeEventListener('DOMContentLoaded', this.readyHandler);
      document.removeEventListener('cart:updated', this.refreshHandler);
      document.removeEventListener('cart:open', this.refreshHandler);
      window.removeEventListener('pageshow', this.refreshHandler);
      window.removeEventListener('focus', this.refreshHandler);
      this.initialized = false;
      this.bound = false;
    }

    queueRefresh() {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(() => this.refreshCart(), 150);
    }

    async refreshCart() {
      this.requestController?.abort();
      const controller = new AbortController();
      this.requestController = controller;
      try {
        const response = await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        if (!response.ok) return;
        const cart = await response.json();
        if (controller.signal.aborted || !this.isConnected) return;
        if (!Number.isFinite(cart.total_price) || !Number.isFinite(cart.item_count)) return;
        this.renderCart(cart);
      } catch (error) {
        if (error.name !== 'AbortError') return;
      }
    }

    formatMoney(cents) {
      const language = document.documentElement.lang || 'es-MX';
      const locale = language.toLowerCase().startsWith('es') ? 'es-MX' : language;
      const amount = new Intl.NumberFormat(locale, { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'narrowSymbol', minimumFractionDigits: cents % 100 === 0 ? 0 : 2, maximumFractionDigits: 2 }).format(cents / 100);
      return `${amount} ${this.dataset.currency}`;
    }

    label(name, cents) {
      return this.dataset[name].replace('__AMOUNT__', this.formatMoney(cents));
    }

    renderCart(cart) {
      if (cart.item_count === 0 || cart.currency !== this.dataset.currency) {
        this.dataset.state = 'empty';
        this.totalElement.textContent = this.dataset.initialLabel;
        this.resultElement.textContent = this.label('fromLabel', this.threshold);
        this.detailElement.hidden = true;
        return;
      }
      const remaining = Math.max(0, this.threshold - cart.total_price);
      this.dataset.state = remaining === 0 ? 'reached' : 'remaining';
      this.totalElement.textContent = this.label('totalLabel', cart.total_price);
      this.resultElement.textContent = remaining === 0 ? this.dataset.reachedLabel : this.label('remainingLabel', remaining);
      this.detailElement.textContent = this.dataset.detailLabel;
      this.detailElement.hidden = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(() => {
  const instances = new Map();
  function initialize(root) {
    if (instances.has(root)) return;
    const main = root.querySelector('.td-main');
    const labels = Array.from(root.querySelectorAll('.td-desktop-menu .td-link-label'));
    const accordions = Array.from(root.querySelectorAll('.td-mobile-menu'));
    const mobile = window.matchMedia('(max-width: 749px)');
    let scheduled = false;
    function resize() {
      if (scheduled || mobile.matches) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        if (!root.isConnected || mobile.matches) return;
        const height = Math.max(32, ...labels.map(label => Math.ceil(label.scrollHeight + 8)));
        const value = `${height}px`;
        if (root.style.getPropertyValue('--td-equal-height') !== value) root.style.setProperty('--td-equal-height', value);
      });
    }
    function closeOthers(event) {
      if (!event.currentTarget.open) return;
      accordions.forEach(accordion => {
        if (accordion !== event.currentTarget) accordion.open = false;
      });
    }
    function changeViewport() {
      accordions.forEach(accordion => { accordion.open = false; });
      resize();
    }
    accordions.forEach(accordion => accordion.addEventListener('toggle', closeOthers));
    mobile.addEventListener('change', changeViewport);
    const observer = new ResizeObserver(resize);
    observer.observe(main);
    instances.set(root, () => {
      observer.disconnect();
      mobile.removeEventListener('change', changeViewport);
      accordions.forEach(accordion => accordion.removeEventListener('toggle', closeOthers));
    });
    if (document.fonts) document.fonts.ready.then(resize);
    resize();
  }
  function initializeAll(scope) {
    if (scope.matches && scope.matches('[data-td-footer]')) initialize(scope);
    scope.querySelectorAll('[data-td-footer]').forEach(initialize);
  }
  initializeAll(document);
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((dispose, root) => {
      if (event.target.contains(root)) {
        dispose();
        instances.delete(root);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
